
export default {
  name: "FormInput",

  props: {
    errorText: {
      type: String,
      required: false,
      default: 'Error'
    },

    value: {
      type: String,
      required: false,
    },

    type: {
      type: String,
      required: false,
      default: 'text'
    },
    numLength: {
      type: String,
      required: false,
      default: ''
    },    
    maxlength: {
      type: String,
      required: false,
      default: ''
    },
    min: {
      type: Number,
      required: false,
      default: null
    },
    max: {
      type: Number,
      required: false,
      default: null
    },

    placeholder: {
      type: String,
      required: false,
      default: ''
    },

    textalign: {
      type: String,
      required: false,
      default: ''
    },

    mb: {
      type: Number,
      required: false,
      default: 0
    },

    height: {
      type: Number,
      required: false,
      default: null
    },

    left: {
      type: Number,
      required: false,
      default: 50
    },

    hasError: {
      type: Boolean,
      required: false,
      default: false,
    },
    autocomplete: {
      type: String,
      required: false,
      default: 'off'
    },
    addElement: {
      type: Boolean,
      required: false,
      default: false,
    },    
  },


  mixins: [],
  components: {},
  data() {
    return {
      showPassword: false,
    }
  },
  computed: {
    eyeIcon() {
      return this.showPassword ? "eye" : "eye-slash";
    },
    inputType() {
      return this.showPassword ? "text" : this.type;
    },    
  },
  mounted() {
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value)
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    }
  }
}
